import {
  IPendingSection2Repository,
  ReassignCompleterPayload,
} from '../ports/outbound/IPendingSection2Repository';
import { PendingSection2Result } from '../domain/entities/PendingSection2Result';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";
import { I9ListingFilters } from '@/shared/application/domain/entities/I9ListingFilters';

export class FetchPendingSection2ItemsUseCase {
  constructor(private repo: IPendingSection2Repository) {}

  async fetchPendingSection2Records(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder,
    filters?: I9ListingFilters
  ): Promise<PendingSection2Result> {
    return this.repo.fetchPendingSection2Records(page, pageSize, columnName, sortOrder, filters);
  }

  async deleteRemoteI9(i9FormId: string): Promise<string> {
    return this.repo.deleteRemoteI9(i9FormId);
  }

  async reassignRemoteCompleter(
    i9FormId: string,
    payload: ReassignCompleterPayload
  ): Promise<void> {
    return this.repo.reassignRemoteCompleter(i9FormId, payload);
  }

  async sendCompleterReviewEmail(i9FormId: string): Promise<void> {
    return this.repo.sendCompleterReviewEmail(i9FormId);
  }
}
